module.exports = __webpack_public_path__ + "img/Computer.49c58410.svg";